// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1n8NU","title":"Info_title__1dWYu","links":"Info_links__12fn6","link":"Info_link__3RR0K","logo":"Info_logo__36Zvz"};